import {} from '@angular/google-maps';
import { EPosition } from '@summit/models';

import { assignSafe } from '@summit/core';
import { ISMapPolyLine } from './i-s-map-polyLine';

export class SMapPolyline implements ISMapPolyLine {
  id: string;
  points: EPosition[];
  icons: any[];

  constructor(jsonData?: Partial<SMapPolyline>) {
    //Pre clean up
    //Normal
    assignSafe(this, jsonData);
    // console.log(`Created ${JSON.stringify(this, null, 2)} from ${JSON.stringify(jsonData, null, 2)}`)
    this.points ??= [];
    this.icons ??= [];
  }

  getLatLngArray(): { lat: number; lng: number }[] {
    return this.points
      .filter((point) => point.latitude !== undefined && point.longitude !== undefined)
      .map((element) => {
        return { lat: element.latitude!, lng: element.longitude! };
      });
  }
}
